import React, {Suspense} from 'react'
import Loader from 'shared/Loader'

// ==============================|| LOADABLE - LAZY LOADING ||============================== //

const Loadable = (Component: any) => (props: any) => (
    <Suspense fallback={<Loader />}>
        <Component {...props} />
    </Suspense>
)

export default Loadable
